import { useState, useEffect, useRef } from 'react';
import { Display } from '../../Display/Display';
import s from '../style.module.scss';
import { contentType } from '@/utils/Page/constant';
import { insertModal, removeModal } from '@/utils/Page/modal';
import DataList from '@/pages/Web/PageComponents/Modals/DataList';
import MyIcon from '@/components/MyIcon';
import { inject, observer } from 'mobx-react';
import { Tooltip } from 'antd';
const WebFileSearchDisplay = (props) => {
    let { modalStore } = props.store;
    const { addExpandModalId, removeExpandModalId, expandModalIds, clearExpandModalIds } = modalStore;
    let { fileList, needSearch = false, total = 0, type, messageId } = props;

    let seconds = useRef(0);
    const timerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        if (needSearch) {
            if (fileList.length === 0) {
                setIsComplete(true);
                return;
            }

            timerRef.current = setInterval(() => {
                seconds.current += 0.05;
                if (seconds.current === 2) {
                    clearInterval(timerRef.current);
                    return false;
                }
                setCurrentIndex((prev) => {
                    if (prev >= fileList.length - 1) {
                        clearInterval(timerRef.current);
                        setIsComplete(true);
                        return prev;
                    }
                    return prev + 1;
                });
            }, 50);
        } else {
            setIsComplete(true);
        }

        return () => clearInterval(timerRef.current);
    }, [fileList]);
    const closeModal = () => {
        clearExpandModalIds();
        removeModal();
    };
    const onClick = () => {
        if (expandModalIds.includes(messageId)) {
            removeExpandModalId(messageId);
            removeModal();
        } else {
            clearExpandModalIds();
            addExpandModalId(messageId);
            insertModal(<DataList dataList={props?.fileList} fileType={props.type} onClose={closeModal}></DataList>);
        }
    };
    return (
        <div className={s['file-box']}>
            <Display show={fileList.length > 0 && !isComplete}>
                <div className={s['un-complete']}>
                    <Display show={type === contentType.retrieval}>
                        <div data-text="正在搜索知识资料库" className={`${s['tip-text']} loading-text`}>
                            正在搜索知识资料库：
                        </div>
                    </Display>
                    <Display show={type === contentType.web_search}>
                        <div data-text="正在全网搜索" className={`${s['tip-text']} loading-text`}>
                            正在全网搜索：
                        </div>
                    </Display>

                    <div className={s['current-file']}>{fileList[currentIndex]?.title}</div>
                </div>
            </Display>
            <Display show={isComplete}>
                <div onClick={onClick} className={s['complete']}>
                    <Display show={type === contentType.retrieval}>
                        <span> 参考资料</span>
                    </Display>
                    <Display show={type === contentType.web_search}>
                        <span> 已搜索到{total}个网页</span>
                    </Display>
                    <Display show={!expandModalIds.includes(messageId)}>
                        <Tooltip title="展开">
                            <div>
                                <MyIcon type="icon-zhankai"></MyIcon>
                            </div>
                        </Tooltip>
                    </Display>
                    <Display show={expandModalIds.includes(messageId)}>
                        <Tooltip title="收起">
                            <div>
                                <MyIcon type="icon-shouqi"></MyIcon>
                            </div>
                        </Tooltip>
                    </Display>

                    {/* <RightOutlined /> */}
                </div>
            </Display>
        </div>
    );
};

export default inject('store')(observer(WebFileSearchDisplay));
